import { Map, Record } from "immutable"

import {
    toUI as defaultToUI,
    toAPI as defaultToAPI,
    normaliseModel,
    hydrateModel,
    updateChangeModel,
    updateCreateModel
} from "../model-utils"
import moment from "moment"

export const CommunityModel = new Record({
    id: "",
    awaiting_approval: [],
    communities: [],
    creator: null,
    description: "",
    dimensions: [],
    followers: [],
    image_url: "",
    imagePreviewURL: undefined,
    invited: [],
    is_manager: false,
    labels: [],
    last_updated: moment(),
    managers: [],
    member_count: 0,
    members: [],
    name: "",
    open_feed: false,
    org: "",
    parent: null,
    privacy: "public",
    projects: [],
    reference: null,
    source: "TopLink",
    status: "Active",
    sub_communities: [],
    sub_groups: [],
    sub_type: "",
    system_labels: [],
    time: moment(),
    topics: [],
    updated_by: null
})

export function CommunityCreateModel() {
    return Map({
        description: "",
        name: "",
        privacy: "public",
        source: "TopLink",
        status: "Active"
    })
}

const dateFields = ["time", "last_updated"]
const tagFields = []
export const normalisingFields = [
    "communities",
    "dimensions",
    "projects",
    "topics"
]
const addRemoveFields = [
    "communities",
    "dimensions",
    "projects",
    "topics",
    "sub_groups",
    "sub_communities",
    "members",
    "managers",
    "followers",
    "invited"
]

export const normalise = feed => normaliseModel(feed, ...normalisingFields)
export const hydrate = (feed, ...entityStates) =>
    hydrateModel(feed, normalisingFields, entityStates)

export const updateCommunityChangeModel = (
    name,
    value,
    changeModel,
    workingModel
) => updateChangeModel(name, value, changeModel, workingModel, addRemoveFields)

export const updateCommunityCreateModel = (
    name,
    value,
    createModel,
    workingModel
) => updateCreateModel(name, value, createModel, workingModel, addRemoveFields)

const labelToUI = label => ({
    id: label,
    name: label
})

const labelToAPI = ({ id }) => id

export const toUI = community => {
    if (community)
        return defaultToUI(community, dateFields, tagFields).set(
            "labels",
            community.get("labels", []).map(labelToUI)
        )
    return community
}

export const toAPI = community => {
    if (community) {
        const defaultTransformation = defaultToAPI(
            community,
            dateFields,
            tagFields
        )
        const labels = community.get("labels", null)
        if (labels !== null)
            return defaultTransformation.set("labels", labels.map(labelToAPI))
    }
    return community
}
